<template>
  <div v-if="visible">
    <a-modal
      v-model:visible="visible"
      title="个人信息"
      :footer="null"
      centered
      @cancel="handleCancel"
    >
      <div class="info">
        <div class="item">
          <span class="title">姓名：</span>
          <span class="content">{{ userInfo.name }}</span>
        </div>
        <div class="item" v-if="userInfo.erpId">
          <span class="title">ERP编号：</span>
          <span class="content">{{ userInfo.erpId }}</span>
        </div>
        <div class="item">
          <span class="title">手机号码：</span>
          <a-button
            @click="callSomeOne"
            v-if="userInfo.phone"
            size="small"
            class="content"
            type="link"
          >
            <template #icon>
              <auth-img width="16" height="16" :src="callIcon" alt="拨打电话" />
            </template>
            {{ userInfo.phone }}
          </a-button>
          <span v-else class="content">{{ '--' }}</span>
        </div>
      </div>
    </a-modal>
    <!--
    电话有效挂断后的弹窗
    NOTE:不允许关闭，只能提交后关闭弹窗
    -->
    <a-modal
      :keyboard="false"
      :maskClosable="false"
      :closable="false"
      v-model:visible="hangup.visible"
      title="主动服务小结"
    >
      <template #footer>
        <a-button key="submit" type="primary" @click="onSaveService">提交</a-button>
      </template>
      <a-form :labelCol="{ style: { width: '80px' } }" :model="hangup.form">
        <a-form-item label="服务事项" v-bind="validateInfos.serviceMatters" name="serviceMatters">
          <a-select
            allowClear
            v-model:value="hangup.form.serviceMatters"
            :options="hangup.options"
          ></a-select>
        </a-form-item>
        <a-form-item label="备注" name="mattersRemark">
          <a-textarea
            :auto-size="{ minRows: 2, maxRows: 5 }"
            allowClear
            v-model:value="hangup.form.mattersRemark"
            :maxlength="200"
            showCount
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>
<script setup>
import { callOut } from '@/utils/Tccc'
import callIcon from '@/assets/img/callout.png'
import { ref, defineExpose, defineEmits, createVNode, computed, watch, reactive } from 'vue'
import { getUserInfoByType } from '@/api/UserPool'
// import store from '@/store'
import { ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { message, Modal } from 'ant-design-vue'
import { useStore } from 'vuex'
import { getMattersList, updateMatters } from '@/api/HealthRecord'
import useRevisitPoolGuard from '@/hooks/useRevisitPoolGuard'
import { Form } from 'ant-design-vue'
import moment from 'moment'
const useForm = Form.useForm
const rulesRef = reactive({
  serviceMatters: [
    {
      required: true,
      message: '必填项'
    }
  ]
})
const hangup = reactive({
  visible: false,
  form: {
    serviceMatters: '',
    mattersRemark: '',
    cdrId: null
  },
  options: []
})
const { validate, validateInfos } = useForm(hangup.form, rulesRef)
const store = useStore()
const visible = ref(false)
const userInfo = ref({})
// 医生下钻患者池时带进来的医生 id（一对一医患关系），用于拨打前校验
const currentUcDoctorId = ref()
const emits = defineEmits(['close'])
//     SYSTEM(0, "系统"),
//     PATIENT(1, "患者"),
//     DOCTOR(2, "医生"),
//     ASSISTANT(3, "BD"),
//     DOCTOR_ASSISTANT(4, "医生助手"),
//     COOPERATIVE_HOSPITAL(5, "合作医院"),
//     CMS(6, "cms"),
//     DOCTOR_HELPER(7, "医生辅助号");
const initModal = params => {
  visible.value = true
  hangup.visible = false
  store.commit('app/SET_FILTER', true)
  // ucDoctorId 只用于拨打前校验，不透传给用户信息接口
  const { ucDoctorId, ...query } = params || {}
  currentUcDoctorId.value = ucDoctorId || undefined
  getUserInfoByType(query)
    .then(res => {
      userInfo.value = res
      initDict()
    })
    .catch(() => {
      userInfo.value = {}
    })
}
// 拨打电话方法
function callSomeOne() {
  const ctxInfo = userInfo.value
  const ctxUserMap = {
    [-1]: '患者',
    1: '患者',
    2: '医生',
    3: 'BD'
  }
  const ctxUser = ctxUserMap[ctxInfo.accountType]
  const doCall = crossPoolParams => {
    hangup.form.cdrId = null
    const params = {
      calleeType: ctxInfo.accountType,
      calleeUcUserId: ctxInfo.accountType === -1 ? ctxInfo.id : ctxInfo.ucUserId,
      doctorId: ctxUser === '医生' ? ctxInfo.id : '',
      // 医生下钻患者池时透传，供 tryJoinActiveFollowup 使用
      ucDoctorId: currentUcDoctorId.value,
      workOrderIds: [],
      businessType: 0,
      // 跨回访池确认拨打埋点参数，随拨打参数透传至 record-save-before-call
      ...crossPoolParams
    }
    callOut(params, {
      userType: ctxUser,
      name: ctxInfo.name
    }).then(result => {
      // console.log('拿到回掉情况', result)
      if (result.cdrId) {
        hangup.form.cdrId = result.cdrId
        const params = {
          cdrId: result.cdrId,
          serviceMatters: '',
          mattersRemark: ''
        }
        updateMatters(params)
      }
    })
  }
  const confirmCall = () => {
    Modal.confirm({
      centered: true,
      title: '确定拨打电话',
      icon: createVNode(ExclamationCircleOutlined),
      content: `确定给${ctxUser}-${ctxInfo.name}拨打电话吗？`,
      okText: '拨打',
      cancelText: '取消',
      onOk: () => doCall()
    })
  }
  // 仅拨打对象为患者时校验回访任务池，医生/BD 无医患关系走原确认流程
  if (ctxInfo.accountType === -1 || ctxInfo.accountType === 1) {
    useRevisitPoolGuard({
      ucPatientId: ctxInfo.accountType === -1 ? ctxInfo.id : ctxInfo.ucUserId,
      // 医生下钻患者池为一对一医患关系，带上该医生的 ucDoctorId
      ucDoctorId: currentUcDoctorId.value,
      source: 'userPool',
      onPass: confirmCall,
      onContinue: doCall
    })
  } else {
    confirmCall()
  }
}
// 提交服务小结
function onSaveService() {
  validate().then(() => {
    const params = {
      cdrId: hangup.form.cdrId,
      serviceMatters: hangup.form.serviceMatters,
      mattersRemark: hangup.form.mattersRemark
    }
    updateMatters(params).then(result => {
      hangup.visible = false
    })
  })
}
const handleCancel = () => {
  store.commit('app/SET_FILTER')
  emits('close')
}
function initDict() {
  const ctxInfo = userInfo.value
  hangup.options = []
  hangup.form.mattersRemark = ''
  //1 患者 2 医生 3BD
  getMattersList(ctxInfo.accountType).then(result => {
    // console.log(result)
    hangup.options = result
    const defaultVal = result[0].value
    hangup.form.serviceMatters = defaultVal
  })
}
const callStatus = computed(() => store.state.tccc.tcccStatus)
let startCall = ''
let endCall = ''
watch(callStatus, (newState, oldState) => {
  // 开始记录时间
  if (newState === 'Accept') {
    startCall = new Date()
    endCall = ''
  } else if (newState === 'RingOff') {
    // 结束通话记录时间
    endCall = new Date()
    console.log(endCall, startCall)
    // console.log('当前通话状态', newState)
    const EffectiveStatus = newState === 'RingOff' && oldState === 'Accept'
    const EffectiveTime = moment(endCall).diff(moment(startCall), 's') > 6
    if (EffectiveStatus && EffectiveTime) {
      // console.log('电话挂断')
      // 需求调整：通话结束不再自动弹出「主动服务小结」弹窗，先注释保留
      // hangup.visible = true
    }
  }
})
defineExpose({ initModal })
</script>
<style scoped lang="scss">
.info {
  font-weight: 400;
  font-size: 14px;
  color: #666666;
  .item {
    display: flex;
    margin-bottom: 6px;
    align-items: center;
    .title {
      width: 70px;
      text-align: right;
    }
    .content {
      padding: 0;
    }
  }
}
</style>
